import { Campaign } from '../types';

export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_TEST = process.env.REACT_APP_EXEC_ENV === 'test';

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_PROD_API) {
    return 'https://new-api.embedgames.app';
  }

  if (IS_DEV) return 'http://localhost:3100';

  if (IS_TEST) return 'https://new-api-test.embedgames.app';

  return 'https://new-api.embedgames.app';
};

export const cdnUrl = 'https://istatic.akamaized.net';

export const STANDALONE_LANDING_URL = 'https://embedgames.app';

const getAppUrl = (platform: SitePlatform): string => {
  if (platform === 'standalone') {
    return 'https://app.embedgames.app';
  }

  return 'https://wix.embedgames.app';
};

export const getEmbedPageUrl = (campaign: Campaign, opts: { insertToPage?: boolean; shouldReduceUISize: boolean }) => {
  const { wixInstanceId, userUuid, id } = campaign;
  const { insertToPage, shouldReduceUISize } = opts;

  const platform = wixInstanceId ? 'wix' : 'standalone';

  const url = new URL(`${getAppUrl(platform)}/embed/${id}`);

  wixInstanceId && url.searchParams.append('wixInstanceId', wixInstanceId);
  userUuid && url.searchParams.append('userUuid', userUuid);
  insertToPage && url.searchParams.append('insertToPage', '1');
  shouldReduceUISize && url.searchParams.append(SHOULD_REDUCE_UI_SIZE_PARAM_NAME, '1');

  return url.toString();
};

export const getUserWidgetUrl = (campaign: Campaign): string => {
  const { wixInstanceId, userUuid, id } = campaign;

  const platform = wixInstanceId ? 'wix' : 'standalone';
  const isWix = platform === 'wix';

  const url = new URL(getAppUrl(platform));

  url.pathname = `/${isWix ? 'wix' : 'widget'}/${wixInstanceId || userUuid}/${id}`;

  return url.toString();
};

export const AppId = '3331cd0a-4955-48c5-a5d9-6bb267a6064f';

export const CONTACT_EMAIL = 'support@popup-games.online';

export const COUPON_DISPLAY_NAME_MAX_LENGTH = 40;

export const WIX_APP_MARKET_LINK = 'https://www.wix.com/app-market/popup-games';

export const WIX_REVIEW_LINK = `https://www.wix.com/app-market/add-review/${AppId}`;

export const YM_COUNTER = 95098183;

export type SitePlatform = 'wix' | 'standalone';

export const SHOULD_REDUCE_UI_SIZE_PARAM_NAME = 'shouldReduceUISize';

export const getPlatform = (): SitePlatform => {
  if (process.env.REACT_APP_PLATFORM) {
    return process.env.REACT_APP_PLATFORM as SitePlatform;
  }

  if (window.origin === 'https://wix.embedgames.app') {
    return 'wix';
  }

  return 'standalone';
};

export const shouldReduceUISize = (): boolean => {
  if (window.self !== window.top) {
    const searchParams = new URLSearchParams(window.location.search);

    return Boolean(searchParams.get(SHOULD_REDUCE_UI_SIZE_PARAM_NAME));
  }

  return false;
};
